import gbAntInputNumberUnit from "./src/gb-ant-input-number-unit.vue";
const gbAntInputNumberUnitCompenet = function(Vue) {
  Vue.component(gbAntInputNumberUnit.name, gbAntInputNumberUnit);
};
export default gbAntInputNumberUnitCompenet;
